import { bindActionCreators } from 'redux';

import CartActions from '../../actions/cart';
import CustomerActions from '../../actions/customer';
import PriceActions from '../../actions/price';
import ProductActions from '../../actions/product';

export default {
  defaultProps: {
    needsType: null,
  },
  // @ts-expect-error - Automatic, Please fix when editing this file
  mapDispatchToProps: (dispatch) => ({
    actions: {
      cart: bindActionCreators(CartActions, dispatch),
      customer: bindActionCreators(CustomerActions, dispatch),
      price: bindActionCreators(PriceActions, dispatch),
      product: bindActionCreators(ProductActions, dispatch),
    },
  }),
};
